export const PULSE_ISSUER = {
    name: 'PULSE INSURANCE',
    legalName: 'PULSE INSURANCE',
    address: '887Q+77P',
    locality: 'Farato, WCR.',
    country: 'Gambia.',
    tel: '7959000'
};

const PRINT_KEY = 'pulse_motor_certificate_print';

export function isMotorPolicy(policy) {
    if (!policy) return false;
    if (policy.vehicle && (policy.vehicle.registrationNumber || policy.vehicle.make)) return true;
    const t = String(policy.policyType || policy.categoryName || policy.coverageType || policy.productName || '').toLowerCase();
    return t.includes('motor') || t.includes('tpo') || t.includes('tpft') || t.includes('third') || t.includes('comprehensive');
}

export function coverClassLabel(policy) {
    const raw = String(policy.coverageType || policy.productName || policy.productId || '').toLowerCase();
    if (raw.includes('comp')) return 'COMPREHENSIVE';
    if (raw.includes('tpft') || raw.includes('fire')) return 'THIRD PARTY, FIRE & THEFT';
    return 'THIRD PARTY';
}

export function useClassLabel(policy) {
    const use = String((policy.vehicle && policy.vehicle.use) || 'private').toLowerCase();
    if (use.includes('taxi') || use.includes('commercial')) return 'X.2 (COMMERCIAL)';
    if (use.includes('goods')) return 'X.3 (GOODS VEHICLE)';
    return 'X.1 (PRIVATE INDIVIDUAL)';
}

export function certificateSerial(policy) {
    const digits = String(policy.policyNumber || policy.id || '0').replace(/\D/g, '');
    if (digits.length >= 6) return digits.slice(-6);
    let n = 0;
    const src = String(policy.id || policy.policyNumber || 'PULSE');
    for (let i = 0; i < src.length; i += 1) n = (n * 31 + src.charCodeAt(i)) >>> 0;
    return String(100000 + (n % 900000));
}

export function toDate(value) {
    if (!value) return null;
    if (typeof value.toDate === 'function') return value.toDate();
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function formatLongDate(value) {
    const d = toDate(value);
    if (!d) return '—';
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatIssuedStamp(value) {
    const d = toDate(value) || new Date();
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let h = d.getHours();
    const ampm = h >= 12 ? 'pm' : 'am';
    h = h % 12 || 12;
    const mm = String(d.getMinutes()).padStart(2, '0');
    return days[d.getDay()] + ' ' + months[d.getMonth()] + ' ' + String(d.getDate()).padStart(2, '0') + ', ' + d.getFullYear() + ' : ' + String(h).padStart(2, '0') + ':' + mm + ':' + ampm;
}

export function vehicleTitle(policy) {
    const v = policy.vehicle || {};
    return [v.make, v.model].filter(Boolean).join(' ').toUpperCase() || '—';
}

export function openMotorCertificatePrint(payload) {
    const row = Array.isArray(payload) ? { certificates: payload } : payload;
    window.sessionStorage.setItem(PRINT_KEY, JSON.stringify(row));
    window.open('/print/motor-certificate', '_blank', 'noopener,width=900,height=1200');
}

export function readMotorCertificatePrint() {
    try {
        const raw = window.sessionStorage.getItem(PRINT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        return null;
    }
}

export function printPayloadFromPolicy(policy, customer, extras) {
    const holder = (policy && policy.policyHolder) || customer || {};
    return {
        policy,
        customer: {
            fullName: holder.fullName || (customer && customer.fullName) || '',
            nationalId: holder.nationalId || (customer && customer.nationalId) || '',
            tin: holder.tin || (customer && customer.tin) || '0',
            phone: holder.phone || (customer && customer.phone) || ''
        },
        managerName: (extras && extras.managerName) || (policy && policy.approvedByName) || (policy.digitalStamp && policy.digitalStamp.managerName) || (policy.digitalSignature && policy.digitalSignature.signerName) || '',
        examinedBy: (extras && extras.examinedBy) || (policy && policy.approvedByName) || (policy.digitalSignature && policy.digitalSignature.signerName) || '',
        issuedAt: (extras && extras.issuedAt) || policy.approvedDate || policy.approvedAt || policy.createdAt || new Date().toISOString(),
        signature: (extras && extras.signature) || (policy && policy.digitalSignature) || null
    };
}
